<template>
  <div ref="container" class="overflow-hidden">
    <div class="flex justify-end" :style="containerStyle">
      <div v-for="(price, idx) in prices" :key="idx" :style="{ height: barHeight(price.count) }" class="chart-col grow bg-gray-400" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    prices: { type: Array, required: true },
    minPrice: { type: Number, required: true },
    maxPrice: { type: Number, required: true },
    show: { type: Boolean, required: true },
  },

  data: () => ({
    height: 65,
  }),

  computed: {
    maxCount () {
      return Math.max(...this.prices.map(p => p.count))
    },

    containerStyle () {
      if (! this.show || ! this.$refs.container) { return }
      const width = this.$refs.container.clientWidth
      const range = this.maxPrice - this.minPrice
      const marginLeft = this.minPrice * (width / range)
      const marginRight = (Math.ceil(this.maxPrice / 50) * 50 - this.maxPrice) * (width / range)

      return {
        marginLeft: `-${marginLeft}px`,
        marginRight: `-${marginRight}px`,
      }
    },
  },

  methods: {
    barHeight (count) {
      return `${this.height / this.maxCount * count}px`
    },
  },
}
</script>

<style lang="scss">
  .chart-col {
    margin: auto 2px 0 2px; background-color: #E0E2F8;
  }
</style>
